:host {
  display: block;
  min-width: 0;
  min-height: 0;
  height: 100%;
  background: transparent;
}

:host([responsive-mode='mobile']) {
  width: 100%;
  background: var(--color-background-primary);
}

.shell-tools__desktop,
.shell-tools__desktop ds-panel-tools,
.shell-tools__mobile {
  display: block;
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.shell-tools__slot-proxy {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
}

.shell-tools__mobile {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  background: var(--color-background-primary);
}

.shell-tools__mobile-header {
  grid-row: 1;
}

.shell-tools__mobile-body,
.shell-tools__view {
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.shell-tools__mobile-body {
  grid-row: 2;
  overflow: hidden;
}

.shell-tools__view {
  overflow: auto;
  overscroll-behavior: contain;
}

.shell-tools__view[hidden] {
  display: none;
}

.shell-tools__view ::slotted(*) {
  min-height: 0;
}
